// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Colori dal prototipo "Demo Onboarding Flusso Prova". */
.dc {
  position: fixed;
  right: 24px;
  bottom: 24px;
  /* Sotto il giro guidato (9000): mentre il tour parla, la chat non deve
     coprire il fumetto. Sopra tutto il resto dell'app. */
  z-index: 8000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

/* ── La mascotte, in tre misure ───────────────────────────────────────────── */
.dc-goccia {
  display: block;
  width: 20px;
  height: 22px;
  background: #f25c04;
  border-radius: 48% 48% 42% 42%/62% 62% 34% 34%;
  position: relative;
}
.dc-goccia i {
  position: absolute;
  left: 7px;
  top: 8px;
  width: 2.5px;
  height: 5px;
  background: #000;
  border-radius: 1.5px;
}
.dc-goccia i.destro {
  left: auto;
  right: 7px;
}
.dc-goccia.grande {
  width: 24px;
  height: 27px;
}
.dc-goccia.grande i {
  left: 8px;
  top: 9px;
  width: 3px;
  height: 6px;
  border-radius: 2px;
}
.dc-goccia.grande i.destro {
  left: auto;
  right: 8px;
}
.dc-goccia.piccola {
  width: 13px;
  height: 15px;
}
.dc-goccia.piccola i {
  display: none;
}

.dc-online {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #29c366;
  border: 2px solid #fff;
}
.dc-online.sul-fab {
  width: 12px;
  height: 12px;
  border-color: #212c5f;
}

/* ── Pannello ─────────────────────────────────────────────────────────────── */
.dc-pannello {
  width: 340px;
  max-width: calc(100vw - 48px);
  height: 430px;
  max-height: calc(100vh - 140px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 56px rgba(33, 44, 95, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: dc-entra 0.25s ease;
}

@keyframes dc-entra {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.dc-testa {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #e4e6ef;
}

.dc-avatar {
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #212c5f;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dc-chi {
  flex: 1;
  min-width: 0;
}

.dc-nome {
  font-size: 14.5px;
  font-weight: 800;
  color: #212c5f;
}

.dc-stato {
  font-size: 11px;
  color: #5a6a8a;
}

.dc-chiudi {
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #f4f6f8;
  border: none;
  color: #5a6a8a;
  font-size: 14px;
  cursor: pointer;
}

.dc-flusso {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.dc-riga {
  display: flex;
  gap: 7px;
  align-items: flex-end;
}
.dc-riga.io {
  justify-content: flex-end;
}
.dc-riga.sistema {
  justify-content: center;
}

.dc-riga-avatar {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #212c5f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dc-bolla {
  max-width: 80%;
  padding: 9px 12px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.45;
  white-space: pre-wrap;
}
.dc-bolla.bot {
  background: #fff;
  border: 1px solid #e4e6ef;
  color: #212c5f;
}
.dc-bolla.io {
  background: #2f6bff;
  color: #fff;
}
.dc-bolla.sistema {
  background: #fff4e5;
  color: #8a5a00;
  font-size: 12.5px;
}

.dc-azioni {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 10px 12px 4px;
  background: #f9fafb;
}
.dc-azioni button {
  border-radius: 14px;
  padding: 6px 12px;
  font-size: 12.5px;
  cursor: pointer;
  white-space: nowrap;
}

.dc-tour {
  border: 1.5px solid #c9d3e4;
  background: #fff;
  color: #2f6bff;
  font-weight: 700;
}
.dc-tour:hover {
  border-color: #2f6bff;
  background: #f4f8ff;
}

.dc-prova {
  border: none;
  background: #f25c04;
  color: #fff;
  font-weight: 800;
}
.dc-prova:hover {
  background: #d94f03;
}

.dc-form {
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  padding: 10px 12px 12px;
  background: #f9fafb;
}
.dc-form input {
  flex: 1;
  min-width: 0;
  height: 40px;
  border: 1px solid #e4e6ef;
  border-radius: 9px;
  padding: 0 12px;
  font-size: 13.5px;
  color: #212c5f;
  outline: none;
  background: #fff;
}
.dc-form input:focus {
  border-color: #2f6bff;
}
.dc-form button {
  height: 40px;
  padding: 0 14px;
  border: none;
  border-radius: 9px;
  background: #2f6bff;
  color: #fff;
  font-weight: 800;
  font-size: 13.5px;
  cursor: pointer;
}
.dc-form button:hover {
  background: #1f4fd1;
}
.dc-form button[disabled] {
  opacity: 0.5;
  cursor: default;
}

/* ── Pulsante ─────────────────────────────────────────────────────────────── */
.dc-fab {
  height: 56px;
  border-radius: 999px;
  background: #212c5f;
  box-shadow: 0 8px 24px rgba(33, 44, 95, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px 0 8px;
  position: relative;
  /* Lo stesso battito della CTA in barra: sono i due inviti all'azione della
     demo e si riconoscono dal movimento. */
  animation: dc-pulse 2.2s ease-out infinite;
}

@keyframes dc-pulse {
  0% {
    box-shadow: 0 8px 24px rgba(33, 44, 95, 0.4), 0 0 0 0 rgba(33, 44, 95, 0.45);
  }
  100% {
    box-shadow: 0 8px 24px rgba(33, 44, 95, 0.4), 0 0 0 14px rgba(33, 44, 95, 0);
  }
}
.dc-fab-avatar {
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.dc-fab-testi {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.dc-fab-nome {
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  white-space: nowrap;
}

.dc-fab-stato {
  font-size: 11px;
  color: #aed3f2;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/desktop/demo-chat/demo-chat.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,yDAAA;AASA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA;yDAAA;EAEA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AANF;;AASA,gFAAA;AACA;EACE,cAAA;EACA,WAAA;EAAa,YAAA;EACb,mBAvBQ;EAwBR,8CAAA;EACA,kBAAA;AALF;AAOE;EACE,kBAAA;EAAoB,SAAA;EAAW,QAAA;EAC/B,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,oBAAA;AAAjD;AACI;EAAW,UAAA;EAAY,UAAA;AAG3B;AAAE;EACE,WAAA;EAAa,YAAA;AAGjB;AAFI;EAAI,SAAA;EAAW,QAAA;EAAU,UAAA;EAAY,WAAA;EAAa,kBAAA;AAStD;AARQ;EAAW,UAAA;EAAY,UAAA;AAY/B;AAVE;EACE,WAAA;EAAa,YAAA;AAajB;AAZI;EAAI,aAAA;AAeR;;AAZA;EACE,kBAAA;EAAoB,SAAA;EAAW,WAAA;EAC/B,WAAA;EAAa,YAAA;EAAc,kBAAA;EAC3B,mBA1CQ;EA0CY,sBAAA;AAoBtB;AAnBE;EAAY,WAAA;EAAa,YAAA;EAAc,qBAjD/B;AAyEV;;AArBA,gFAAA;AACA;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,8BAAA;AAwBF;;AAtBA;EACE;IAAO,UAAA;IAAY,2BAAA;EA2BnB;EA1BA;IAAO,UAAA;IAAY,eAAA;EA8BnB;AACF;AA5BA;EACE,cAAA;EACA,aAAA;EAAe,mBAAA;EAAqB,SAAA;EACpC,kBAAA;EAAoB,gCAAA;AAiCtB;;AA/BA;EACE,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAC3C,mBA9EQ;EA8EW,kBAAA;EACnB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;AAwCtC;;AAtCA;EAAU,OAAA;EAAS,YAAA;AA2CnB;;AA1CA;EAAY,iBAAA;EAAmB,gBAAA;EAAkB,cAlFvC;AAkIV;;AA/CA;EAAY,eAAA;EAAiB,cAlFnB;AAsIV;;AAnDA;EACE,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAC3C,mBAAA;EAAqB,YAAA;EAAc,cArF3B;EAsFR,eAAA;EAAiB,eAAA;AA4DnB;;AAzDA;EACE,OAAA;EAAS,aAAA;EAAe,gBAAA;EACxB,aAAA;EAAe,mBAAA;EACf,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAiEzC;;AA/DA;EACE,aAAA;EAAe,QAAA;EAAU,qBAAA;AAoE3B;AAnEE;EAAO,yBAAA;AAsET;AArEE;EAAY,uBAAA;AAwEd;;AAtEA;EACE,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAC3C,mBAtGQ;EAsGW,aAAA;EAAe,mBAAA;EAAqB,uBAAA;AA+EzD;;AA7EA;EACE,cAAA;EAAgB,iBAAA;EAAmB,mBAAA;EACnC,iBAAA;EAAmB,iBAAA;EAAmB,qBAAA;AAoFxC;AAnFE;EAAY,gBAAA;EAAkB,yBAAA;EAAyB,cA3G/C;AAmMV;AAvFE;EAAY,mBAzGJ;EAyGsB,WAAA;AA2FhC;AA1FE;EAAY,mBAAA;EAAqB,cAAA;EAAgB,iBAAA;AA+FnD;;AA5FA;EACE,cAAA;EACA,aAAA;EAAe,QAAA;EAAU,eAAA;EACzB,sBAAA;EAAwB,mBAAA;AAkG1B;AAjGE;EAAS,mBAAA;EAAqB,iBAAA;EAAmB,iBAAA;EAAmB,eAAA;EAAiB,mBAAA;AAwGvF;;AAtGA;EACE,2BAAA;EAA6B,gBAAA;EAAkB,cApHvC;EAoHoD,gBAAA;AA4G9D;AA3GE;EAAU,qBArHF;EAqHsB,mBAAA;AA+GhC;;AA7GA;EACE,YAAA;EAAc,mBAzHN;EAyH4B,WAAA;EAAa,gBAAA;AAmHnD;AAlHE;EAAU,mBAAA;AAqHZ;;AAlHA;EACE,cAAA;EACA,aAAA;EAAe,QAAA;EACf,uBAAA;EAAyB,mBAAA;AAuH3B;AAtHE;EACE,OAAA;EAAS,YAAA;EAAc,YAAA;EACvB,yBAAA;EAAyB,kBAAA;EAAoB,eAAA;EAC7C,iBAAA;EAAmB,cAtIb;EAsI2B,aAAA;EAAe,gBAAA;AA+HpD;AA9HI;EAAU,qBApIJ;AAqQV;AA/HE;EACE,YAAA;EAAc,eAAA;EAAiB,YAAA;EAAc,kBAAA;EAC7C,mBAxIM;EAwIY,WAAA;EAAa,gBAAA;EAAkB,iBAAA;EAAmB,eAAA;AAwIxE;AAvII;EAAU,mBAxIF;AAkRZ;AAzII;EAAc,YAAA;EAAa,eAAA;AA6I/B;;AAzIA,gFAAA;AACA;EACE,YAAA;EACA,oBAAA;EACA,mBArJQ;EAsJR,4CAAA;EACA,eAAA;EACA,aAAA;EAAe,mBAAA;EAAqB,SAAA;EACpC,qBAAA;EACA,kBAAA;EACA;2CAAA;EAEA,0CAAA;AA8IF;;AA5IA;EACE;IAAO,4EAAA;EAgJP;EA/IA;IAAO,4EAAA;EAkJP;AACF;AAjJA;EACE,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAC3C,oCAAA;EACA,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EACpC,kBAAA;AAwJF;;AAtJA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,iBAAA;AA4JvD;;AA3JA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,WAAA;EAAa,mBAAA;AAkKhE;;AAjKA;EAAgB,eAAA;EAAiB,cAAA;EAAgB,mBAAA;AAuKjD;AACA,o/XAAo/X","sourcesContent":["/* Colori dal prototipo \"Demo Onboarding Flusso Prova\". */\n$navy:    #212c5f;\n$grigio:  #5a6a8a;\n$arancio: #f25c04;\n$blu:     #2f6bff;\n$blu-scuro: #1f4fd1;\n$riga:    #e4e6ef;\n$verde:   #29c366;\n\n.dc {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  /* Sotto il giro guidato (9000): mentre il tour parla, la chat non deve\n     coprire il fumetto. Sopra tutto il resto dell'app. */\n  z-index: 8000;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n/* ── La mascotte, in tre misure ───────────────────────────────────────────── */\n.dc-goccia {\n  display: block;\n  width: 20px; height: 22px;\n  background: $arancio;\n  border-radius: 48% 48% 42% 42% / 62% 62% 34% 34%;\n  position: relative;\n\n  i {\n    position: absolute; left: 7px; top: 8px;\n    width: 2.5px; height: 5px; background: #000; border-radius: 1.5px;\n    &.destro { left: auto; right: 7px; }\n  }\n\n  &.grande {\n    width: 24px; height: 27px;\n    i { left: 8px; top: 9px; width: 3px; height: 6px; border-radius: 2px;\n        &.destro { left: auto; right: 8px; } }\n  }\n  &.piccola {\n    width: 13px; height: 15px;\n    i { display: none; }\n  }\n}\n.dc-online {\n  position: absolute; top: -1px; right: -1px;\n  width: 11px; height: 11px; border-radius: 50%;\n  background: $verde; border: 2px solid #fff;\n  &.sul-fab { width: 12px; height: 12px; border-color: $navy; }\n}\n\n/* ── Pannello ─────────────────────────────────────────────────────────────── */\n.dc-pannello {\n  width: 340px;\n  max-width: calc(100vw - 48px);\n  height: 430px;\n  max-height: calc(100vh - 140px);\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 20px 56px rgba(33, 44, 95, .3);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: dc-entra .25s ease;\n}\n@keyframes dc-entra {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: none; }\n}\n\n.dc-testa {\n  flex: 0 0 auto;\n  display: flex; align-items: center; gap: 10px;\n  padding: 12px 14px; border-bottom: 1px solid $riga;\n}\n.dc-avatar {\n  width: 38px; height: 38px; flex: 0 0 auto; border-radius: 50%;\n  background: $navy; position: relative;\n  display: flex; align-items: center; justify-content: center;\n}\n.dc-chi { flex: 1; min-width: 0; }\n.dc-nome  { font-size: 14.5px; font-weight: 800; color: $navy; }\n.dc-stato { font-size: 11px; color: $grigio; }\n.dc-chiudi {\n  width: 30px; height: 30px; flex: 0 0 auto; border-radius: 50%;\n  background: #f4f6f8; border: none; color: $grigio;\n  font-size: 14px; cursor: pointer;\n}\n\n.dc-flusso {\n  flex: 1; min-height: 0; overflow-y: auto;\n  padding: 14px; background: #f9fafb;\n  display: flex; flex-direction: column; gap: 9px;\n}\n.dc-riga {\n  display: flex; gap: 7px; align-items: flex-end;\n  &.io { justify-content: flex-end; }\n  &.sistema { justify-content: center; }\n}\n.dc-riga-avatar {\n  width: 24px; height: 24px; flex: 0 0 auto; border-radius: 50%;\n  background: $navy; display: flex; align-items: center; justify-content: center;\n}\n.dc-bolla {\n  max-width: 80%; padding: 9px 12px; border-radius: 12px;\n  font-size: 13.5px; line-height: 1.45; white-space: pre-wrap;\n  &.bot     { background: #fff; border: 1px solid $riga; color: $navy; }\n  &.io      { background: $blu; color: #fff; }\n  &.sistema { background: #fff4e5; color: #8a5a00; font-size: 12.5px; }\n}\n\n.dc-azioni {\n  flex: 0 0 auto;\n  display: flex; gap: 6px; flex-wrap: wrap;\n  padding: 10px 12px 4px; background: #f9fafb;\n  button { border-radius: 14px; padding: 6px 12px; font-size: 12.5px; cursor: pointer; white-space: nowrap; }\n}\n.dc-tour {\n  border: 1.5px solid #c9d3e4; background: #fff; color: $blu; font-weight: 700;\n  &:hover { border-color: $blu; background: #f4f8ff; }\n}\n.dc-prova {\n  border: none; background: $arancio; color: #fff; font-weight: 800;\n  &:hover { background: #d94f03; }\n}\n\n.dc-form {\n  flex: 0 0 auto;\n  display: flex; gap: 8px;\n  padding: 10px 12px 12px; background: #f9fafb;\n  input {\n    flex: 1; min-width: 0; height: 40px;\n    border: 1px solid $riga; border-radius: 9px; padding: 0 12px;\n    font-size: 13.5px; color: $navy; outline: none; background: #fff;\n    &:focus { border-color: $blu; }\n  }\n  button {\n    height: 40px; padding: 0 14px; border: none; border-radius: 9px;\n    background: $blu; color: #fff; font-weight: 800; font-size: 13.5px; cursor: pointer;\n    &:hover { background: $blu-scuro; }\n    &[disabled] { opacity: .5; cursor: default; }\n  }\n}\n\n/* ── Pulsante ─────────────────────────────────────────────────────────────── */\n.dc-fab {\n  height: 56px;\n  border-radius: 999px;\n  background: $navy;\n  box-shadow: 0 8px 24px rgba(33, 44, 95, .4);\n  cursor: pointer;\n  display: flex; align-items: center; gap: 10px;\n  padding: 0 20px 0 8px;\n  position: relative;\n  /* Lo stesso battito della CTA in barra: sono i due inviti all'azione della\n     demo e si riconoscono dal movimento. */\n  animation: dc-pulse 2.2s ease-out infinite;\n}\n@keyframes dc-pulse {\n  0%   { box-shadow: 0 8px 24px rgba(33,44,95,.4), 0 0 0 0  rgba(33,44,95,.45); }\n  100% { box-shadow: 0 8px 24px rgba(33,44,95,.4), 0 0 0 14px rgba(33,44,95,0); }\n}\n.dc-fab-avatar {\n  width: 42px; height: 42px; flex: 0 0 auto; border-radius: 50%;\n  background: rgba(255, 255, 255, .1);\n  display: flex; align-items: center; justify-content: center;\n  position: relative;\n}\n.dc-fab-testi { display: flex; flex-direction: column; line-height: 1.25; }\n.dc-fab-nome  { font-size: 14px; font-weight: 800; color: #fff; white-space: nowrap; }\n.dc-fab-stato { font-size: 11px; color: #aed3f2; white-space: nowrap; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
